import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { useCalculateReward } from './hooks';
import { HighReward } from '../../components/HighReward';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingBrokerRewardTariffsUrl } from '../../utils/config/getNewbuildingBrokerRewardTariffsUrl';

export const HighRewardContainer = () => {
  const { reward, values, handleChangeApartmentPrice, handleChangePercentageReward } = useCalculateReward();
  const device = useDeviceType();
  const { config } = useApplicationContext();
  const rewardTariffsUrl = getNewbuildingBrokerRewardTariffsUrl(config);

  return (
    <HighReward
      deviceType={device}
      reward={reward}
      percentageReward={values.percentageReward}
      apartmentPrice={values.apartmentPrice}
      onChangeApartmentPrice={handleChangeApartmentPrice}
      onChangePercentageReward={handleChangePercentageReward}
      rewardTariffsUrl={rewardTariffsUrl}
    />
  );
};
